import React from "react";
import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category, action, label) => {
   // console.log("🚀 ~ file: useAnalyticsEventTracker.js:5 ~ useAnalyticsEventTracker ~ category:", category);
    const eventTracker = () => {
        ReactGA.event({ category, action, label });
    };
    return eventTracker;
};
export default useAnalyticsEventTracker;